<template>
  <footer>
    <div class="footer"></div>
  </footer>
</template>

<script setup>
import { computed } from "vue";
const color = computed(() => {
  return process.env.VUE_APP_ENV_COLOR;
});
</script>

<style scoped>
footer {
  box-sizing: border-box;
  height: 90px;
  width: 100%;
  background-color: v-bind(color);
}
</style>
